import React from 'react';
import { useParams } from 'react-router-dom';
import { Container, Card, Row, Col, Table, Badge, Button } from 'react-bootstrap';
import './OrderDetail.css';

function OrderDetail() {
  const { id } = useParams();

  const orderData = {
    id: id || '1234',
    customer: 'Jan Novák',
    email: 'jan.novak@email.cz',
    phone: '+420 123 456 789',
    date: '2024-01-15 14:30',
    status: 'completed',
    total: '15 420 Kč',
    items: [
      { id: 1, name: 'Produkt A', quantity: 2, price: '5 200 Kč', total: '10 400 Kč' },
      { id: 2, name: 'Produkt B', quantity: 1, price: '5 020 Kč', total: '5 020 Kč' }
    ],
    shippingAddress: {
      street: 'Hlavní 123',
      city: 'Praha',
      zip: '110 00',
      country: 'Česká republika'
    }
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      completed: { variant: 'success', text: 'Dokončeno' },
      pending: { variant: 'warning', text: 'Čeká' },
      processing: { variant: 'info', text: 'Zpracovává se' },
      cancelled: { variant: 'danger', text: 'Zrušeno' }
    };
    const statusInfo = statusMap[status] || { variant: 'secondary', text: status };
    return <Badge bg={statusInfo.variant}>{statusInfo.text}</Badge>;
  };

  return (
    <Container fluid className="px-4">
      {/* Header Bar */}
      <div className="header-bar mb-4">
        <Container fluid className="px-4">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h4 className="mb-0">Objednávka {orderData.id}</h4>
            </div>
            <div className="col-md-6 text-end">
              <Button variant="outline-primary">
                <i className="bi bi-pencil"></i> Upravit
              </Button>
              <Button variant="outline-secondary" className="ms-2">
                <i className="bi bi-printer"></i> Tisk
              </Button>
            </div>
          </div>
        </Container>
      </div>

      <Row className="g-4">
        <Col lg={8}>
          {/* Order Items */}
          <div className="table-container mb-4">
            <h5 className="mb-3">Položky objednávky</h5>
            <Table responsive>
              <thead className="table-light">
                <tr>
                  <th>Produkt</th>
                  <th>Množství</th>
                  <th>Cena/ks</th>
                  <th>Celkem</th>
                </tr>
              </thead>
              <tbody>
                {orderData.items.map(item => (
                  <tr key={item.id}>
                    <td className="company-name">{item.name}</td>
                    <td>{item.quantity}</td>
                    <td>{item.price}</td>
                    <td><strong>{item.total}</strong></td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="3" className="text-end"><strong>Celkem:</strong></td>
                  <td><strong className="text-primary fs-5">{orderData.total}</strong></td>
                </tr>
              </tfoot>
            </Table>
          </div>

          {/* Shipping Address */}
          <div className="table-container">
            <h5 className="mb-3">Dodací adresa</h5>
            <p className="mb-1">{orderData.shippingAddress.street}</p>
            <p className="mb-1">{orderData.shippingAddress.zip} {orderData.shippingAddress.city}</p>
            <p className="mb-0">{orderData.shippingAddress.country}</p>
          </div>
        </Col>

        <Col lg={4}>
          {/* Order Info */}
          <div className="table-container mb-4">
            <h5 className="mb-3">Informace o objednávce</h5>
            <div className="info-row">
              <span className="info-label">Stav:</span>
              <span>{getStatusBadge(orderData.status)}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Datum:</span>
              <span>{orderData.date}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Číslo:</span>
              <span>#{orderData.id}</span>
            </div>
          </div>

          {/* Customer Info */}
          <div className="table-container">
            <h5 className="mb-3">Zákazník</h5>
            <div className="info-row">
              <span className="info-label">Jméno:</span>
              <span className="company-name">{orderData.customer}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Email:</span>
              <span>{orderData.email}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Telefon:</span>
              <span>{orderData.phone}</span>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default OrderDetail;